import { createTheme } from '@mui/material/styles';
import { lightTheme as jLightTheme, tokens, spacing, radius } from '@gojitsu/web-ui-core';
import colors from './colors';

export const lightTheme = createTheme({
  ...jLightTheme,
  palette: {
    ...jLightTheme.palette,
    third: {
      main: '#6c62f5',
    },
    color: colors,
  },
});

export { tokens, spacing, radius, colors };
